export default {
    de: {
        artikelPdfName: 'Produktinformationen Modell',
        merklistePdfName: 'Merkliste',
    },
    en: {
        artikelPdfName: 'Product information model',
        merklistePdfName: 'Watchlist',
    },
    fr: {
        artikelPdfName: 'Informations sur les produits modèle',
        merklistePdfName: 'Liste des favoris',
    },
    es: {
        artikelPdfName: 'Información sobre el producto modelo',
        merklistePdfName: 'Lista de favoritos',
    },
};
